module.exports = __webpack_public_path__ + "static/media/  (125).ff973c02.jpg";